export default "__VITE_ASSET__78e11769__"